import React from 'react'
import { Button } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

// Entry point on the "all users" home page. The actual creation flow (name,
// join code, admin selection and permissions) lives in the GroupCreate module,
// also reachable from the left-hand nav.
const CreateGroup = () => {
  const navigate = useNavigate()
  const { groupId } = useParams()

  return (
    <Button variant='contained' onClick={() => navigate(`/dashboard/${groupId}/createGroup`)}>
      Create Group
    </Button>
  )
}

export default CreateGroup
